export default "__VITE_ASSET__BHypXI5C__"